/* eslint-disable */
import axios from 'axios';
var qs = require('qs');
var instance = axios.create({
    // baseURL: 'http://hi-api.xbx12.top/',
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json',
    }
});
const ajax = (url, params, type = 'get') => {
    return new Promise((resolve, reject) => {
        instance({
            url: url,
            method: type,
            data: type == 'post' ? params : undefined,
            params: type == 'get' ? {
                ...params,
                _t: new Date().getTime()
            } : undefined
        }).then(res => {

            if (res.status == 200) {
                resolve(res.data);
            } else {
                throw res;
            }
        }).catch(err => {
            console.error(err);
            reject(err);
        })
    })
};

export default ajax;



// WEBPACK FOOTER //
// ./src/js/ajax.js